class Challenges {
    init() {
        jQuery('.challenge-more').on('click', function () {
            jQuery(this).parent().remove();
            var theRest = jQuery('.challenges-the-rest');
            jQuery('.game-challenges').append(theRest.html());
            theRest.remove();
        });
    }

    activate(id) {
        app.ajax.get("/services/challenge/" + id + "/activate/", [], (response) => {
            if (response.status === true) {
                app.modal.close();
                jQuery(".challenge-" + id).addClass("activated");
            }
        });
    }

    deactivate(id) {
        app.ajax.get("/services/challenge/" + id + "/deactivate/", [], (response) => {
            app.modal.close();
            app.events.single("modal_history_back", () => {
                jQuery("#too-many-active-challenges .challenge-" + id).remove();
            });
            jQuery(".challenge-" + id).removeClass("activated");
        });
    }
}
